<script>
import { CookieConsent } from "@travelata-libs/ui-shared";

function getCookieDomain() {
    const { hostname } = window.location;
    const cleanHostname = hostname.replace(/^m\./, '');
    return `.${cleanHostname}`;
}

export default {
  name: "CookieConsentPopup",
  components: { CookieConsent },
  props: {
    cookieName: {
      type: String,
      default: "cookieConsent",
    },
    cookieValue: {
      type: String,
      default: "accepted",
    },
    cookiesUrl: {
      type: String,
      default: `${window.appConfig.travelataUrl}/cookies-agreement`,
    },
    recommendationTechnologyUrl: {
      type: String,
      default: `${window.appConfig.travelataUrl}/recommendation-technologies-agreement`,
    },
    privacyPolicyUrl: {
      type: String,
      default: `${window.appConfig.travelataUrl}/privacy.html`,
    },
    image: {
      type: Boolean,
      default: false,
    },
    domain: {
      type: String,
      default: () => getCookieDomain(),
    },
  },
  computed: {
    isInIframe() {
        const parentHostname = window.location.href;
        return window.self !== window.top || parentHostname.includes('frame');
    }
  }
};
</script>

<template>
    <CookieConsent v-if="!isInIframe" v-bind="$props"/>
</template>

<style scoped lang="scss">
@import '@/css/common/variables.scss';

::v-deep .tl-cookie-consent__link {
    color: var(
            --trav-color-inputs-primary,
            var(
                    --trav-color-primary-400,
                    $trav-color-primary-400
            )
    );
}

::v-deep .tl-cookie-consent__link:hover {
    color: var(
            --trav-color-links-hover,
            var(
                    --trav-color-primary-100,
                    $trav-color-primary-100
            )
    );
}

::v-deep .tl-button {
    background-color: var(
            --trav-color-primary-button,
            var(
                    --trav-color-primary-100,
                    $trav-color-primary-100
            )
    );
    color: var(
            --trav-font-color-primary-button,
            var(
                    --trav-font-color-1200,
                    $trav-font-color-1200,
            )
    );
}

.tl-cookie-consent {
    position: static;
    width: calc(100% - 12px);
}
</style>